module.exports = __webpack_public_path__ + "img/visa.6f752a24.svg";